import React, { useState, useEffect } from "react";

const SUPABASE_URL = "https://dwxstxokyzmkoytpgcau.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR3eHN0eG9reXpta295dHBnY2F1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzUwNTA1NDksImV4cCI6MjA5MDYyNjU0OX0.GQAO_oLIpD0YbBkpu_lrT2LmNIyZ0Jk97WXO0fj8Kkw";
const WHATSAPP_GROUP = "https://chat.whatsapp.com/https://chat.whatsapp.com/E7u8Iv6mPbQ1tzQ7vrcbFc";
const YOUTUBE_ID = "https://youtube.com/shorts/pwbKCmMzps0";

const Trial = () => {
  const [form, setForm] = useState({ nome: "", whatsapp: "", email: "" });
  const [erro, setErro] = useState("");
  const [enviado, setEnviado] = useState(false);
  const [loading, setLoading] = useState(false);
  const [timeLeft, setTimeLeft] = useState(24 * 60 * 60);
  const [openFaq, setOpenFaq] = useState(null);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(t => t <= 0 ? 24 * 60 * 60 : t - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const hh = String(Math.floor(timeLeft / 3600)).padStart(2, "0");
  const mm = String(Math.floor((timeLeft % 3600) / 60)).padStart(2, "0");
  const ss = String(timeLeft % 60).padStart(2, "0");

  const handleSubmit = async () => {
    setErro("");
    if (!form.nome.trim()) { setErro("Digite seu nome."); return; }
    if (!form.whatsapp.trim()) { setErro("Digite seu WhatsApp."); return; }
    if (!form.email.trim() || !form.email.includes("@")) { setErro("Digite o e-mail da sua conta Google."); return; }
    setLoading(true);
    try {
      await fetch(`${SUPABASE_URL}/rest/v1/testadores_site`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "apikey": SUPABASE_ANON_KEY,
          "Authorization": `Bearer ${SUPABASE_ANON_KEY}`,
          "Prefer": "return=minimal"
        },
        body: JSON.stringify({ nome: form.nome, whatsapp: form.whatsapp, email: form.email, criado_em: new Date().toISOString() })
      });
    } catch (err) { console.error(err); }
    finally { setLoading(false); setEnviado(true); }
  };

  const faqs = [
    { q: "Preciso saber de tecnologia?", a: "Não. É só instalar e ativar. Em 2 minutos está funcionando." },
    { q: "Funciona com qualquer celular Android?", a: "Sim, funciona em qualquer Android versão 8 ou superior." },
    { q: "Quando recebo o acesso?", a: "Em até 24h você recebe o e-mail com todas as instruções." },
    { q: "E se eu não gostar?", a: "Sem problema. É um teste privado gratuito, sem compromisso." },
    { q: "Como o Anjora bloqueia jogos chineses?", a: "O app lê o nome do jogo e do site em tempo real e bloqueia automaticamente, mesmo quando o nome muda." },
  ];

  const s = {
    page: { background: "#0d0a08", minHeight: "100vh", color: "#fff", fontFamily: "'Inter', sans-serif", paddingBottom: 60 },
    section: { maxWidth: 480, margin: "0 auto", padding: "48px 20px 0" },
    label: { color: "#f97316", fontSize: 11, fontWeight: 700, letterSpacing: "0.15em", textTransform: "uppercase", marginBottom: 10, display: "block" },
    h1: { fontSize: "clamp(28px, 7vw, 44px)", fontWeight: 800, lineHeight: 1.1, margin: "0 0 16px" },
    h2: { fontSize: "clamp(22px, 5vw, 34px)", fontWeight: 800, lineHeight: 1.15, margin: "0 0 12px" },
    orange: { color: "#f97316" },
    sub: { fontSize: 15, color: "rgba(255,255,255,0.55)", lineHeight: 1.7, margin: "0 0 24px" },
    btn: { display: "block", width: "100%", padding: "18px 24px", background: "#f97316", color: "#fff", border: "none", borderRadius: 50, fontSize: 16, fontWeight: 800, cursor: "pointer", textAlign: "center", letterSpacing: "0.05em", boxShadow: "0 8px 32px rgba(249,115,22,0.35)", marginBottom: 0 },
    btnGreen: { display: "block", width: "100%", padding: "18px 24px", background: "#25d366", color: "#fff", border: "none", borderRadius: 50, fontSize: 16, fontWeight: 800, cursor: "pointer", textAlign: "center", letterSpacing: "0.05em", boxShadow: "0 8px 32px rgba(37,211,102,0.35)" },
    card: { background: "#1a1612", borderRadius: 16, padding: "16px 20px", marginBottom: 12 },
    pip: { display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(249,115,22,0.1)", border: "1px solid rgba(249,115,22,0.3)", borderRadius: 50, padding: "6px 16px", marginBottom: 20 },
    input: { width: "100%", boxSizing: "border-box", padding: "13px 16px", borderRadius: 12, border: "1px solid rgba(255,255,255,0.12)", background: "rgba(255,255,255,0.05)", color: "#fff", fontSize: 15, outline: "none", marginBottom: 10 },
    timerBox: { background: "#1a1612", borderRadius: 12, padding: "14px 20px", textAlign: "center", flex: 1 },
    step: { display: "flex", gap: 16, alignItems: "flex-start", marginBottom: 20 },
    stepNum: { width: 36, height: 36, borderRadius: "50%", background: "#f97316", color: "#fff", fontWeight: 800, fontSize: 16, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 },
    compare: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 0", borderBottom: "0.5px solid rgba(255,255,255,0.06)" },
    faqItem: { borderBottom: "0.5px solid rgba(255,255,255,0.08)", padding: "16px 0", cursor: "pointer" },
  };

  if (enviado) {
    return (
      <div style={s.page}>
        <div style={{ ...s.section, textAlign: "center", paddingTop: 80 }}>
          <div style={{ fontSize: 56, marginBottom: 16 }}>🎉</div>
          <h1 style={{ ...s.h1, fontSize: 28 }}>Cadastro realizado!</h1>
          <p style={s.sub}>Agora falta apenas uma etapa para você começar.</p>
          <div style={{ ...s.card, border: "1px solid rgba(37,211,102,0.25)", textAlign: "center", marginBottom: 24 }}>
            <p style={{ fontSize: 15, fontWeight: 600, margin: "0 0 6px" }}>Entre no nosso grupo de testadores</p>
            <p style={{ fontSize: 13, color: "rgba(255,255,255,0.45)", margin: 0, lineHeight: 1.6 }}>No grupo você recebe o link para o teste fechado, o passo a passo da instalação e pode tirar suas dúvidas.</p>
          </div>
          <button style={s.btnGreen} onClick={() => window.open(WHATSAPP_GROUP, "_blank")}>
            📲 ENTRAR NO GRUPO DO WHATSAPP
          </button>
          <p style={{ fontSize: 12, color: "rgba(255,255,255,0.3)", marginTop: 12 }}>Grupo exclusivo de testadores Anjora</p>
        </div>
      </div>
    );
  }

  return (
    <div style={s.page}>

      {/* HERO */}
      <div style={{ ...s.section, paddingTop: 60, textAlign: "center" }}>
        <div style={s.pip}>
          <span>🧪</span>
          <span style={{ fontSize: 12, color: "#f97316", fontWeight: 600 }}>FASE FINAL DE TESTES</span>
        </div>
        <h1 style={s.h1}>
          Seja um dos primeiros<br />a testar o <span style={s.orange}>Anjora</span>
        </h1>
        <p style={s.sub}>
          Estamos na fase final de testes antes do lançamento oficial na Google Play e precisamos da sua ajuda.
        </p>
        <div style={{ display: "flex", justifyContent: "center", gap: 10, flexWrap: "wrap", marginBottom: 28 }}>
          {["🎁 Teste gratuito", "📱 Android", "👥 Grupo exclusivo"].map((t, i) => (
            <div key={i} style={{ background: "#1a1612", borderRadius: 50, padding: "6px 14px", fontSize: 13, fontWeight: 600 }}>{t}</div>
          ))}
        </div>
        <button style={s.btn} onClick={() => document.getElementById("form").scrollIntoView({ behavior: "smooth" })}>
          QUERO PARTICIPAR DO TESTE
        </button>
        <p style={{ fontSize: 12, color: "rgba(255,255,255,0.3)", marginTop: 10 }}>Acesso em 24h · 100% privado · sem cartão</p>
      </div>

      {/* VÍDEO */}
      <div style={s.section}>
        <div style={{ borderRadius: 16, overflow: "hidden", position: "relative", paddingTop: "100%" }}>
          <iframe
            style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", border: "none", borderRadius: 16 }}
            src="https://www.youtube.com/embed/uOSE7EBVZB4?rel=0&modestbranding=1"
            title="Anjora"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>

      {/* ISSO É PRA VOCÊ SE */}
      <div style={s.section}>
        <span style={s.label}>Isso é pra você se...</span>
        {[
          "Você abre o Instagram e já aparece anúncio de bet.",
          "Já tentou parar mas a vontade bate mais forte que a força de vontade.",
          "Links de apostas chegam no WhatsApp e você não resiste.",
          "Jogos como Fortune Tiger, Aviator e Blaze te prendem de volta.",
        ].map((t, i) => (
          <div key={i} style={s.card}>
            <span style={{ ...s.orange, marginRight: 10, fontSize: 14 }}>♦</span>
            <span style={{ fontSize: 14, lineHeight: 1.6 }}>{t}</span>
          </div>
        ))}
      </div>

      {/* COMO FUNCIONA */}
      <div style={s.section}>
        <span style={s.label}>Sem complicação</span>
        <h2 style={s.h2}>Como funciona</h2>
        {[
          { n: 1, t: "Deixe seus dados", d: "Preencha o formulário abaixo para participar do teste." },
          { n: 2, t: "Entre no grupo", d: "Você será adicionado ao grupo exclusivo de testadores no WhatsApp." },
          { n: 3, t: "Instale e ative", d: "Em 2 minutos o Anjora já está funcionando e bloqueando tudo." },
        ].map((item) => (
          <div key={item.n} style={s.step}>
            <div style={s.stepNum}>{item.n}</div>
            <div style={{ ...s.card, flex: 1, marginBottom: 0 }}>
              <p style={{ fontWeight: 700, fontSize: 14, margin: "0 0 4px" }}>{item.t}</p>
              <p style={{ fontSize: 13, color: "rgba(255,255,255,0.5)", margin: 0 }}>{item.d}</p>
            </div>
          </div>
        ))}
      </div>

      {/* O QUE BLOQUEIA */}
      <div style={s.section}>
        <span style={s.label}>Proteção completa</span>
        <h2 style={s.h2}>O que você nunca<br /><span style={s.orange}>mais vai ver</span></h2>
        {[
          { t: "Sites de apostas", d: "bet365, Betano, Blaze e +100 outros" },
          { t: "Jogos chineses", d: "Fortune Tiger, Aviator, Spaceman, Mines" },
          { t: "Anúncios em redes sociais", d: "Instagram, TikTok, Facebook, YouTube" },
          { t: "Links no WhatsApp e Telegram", d: "Bloqueados antes de abrir" },
          { t: "Sites novos e mascarados", d: "IA detecta e bloqueia automaticamente" },
        ].map((item, i) => (
          <div key={i} style={{ ...s.card, display: "flex", alignItems: "flex-start", gap: 12 }}>
            <span style={{ ...s.orange, fontSize: 14, marginTop: 2 }}>♦</span>
            <div>
              <p style={{ fontWeight: 700, fontSize: 14, margin: "0 0 2px" }}>{item.t}</p>
              <p style={{ fontSize: 12, color: "rgba(255,255,255,0.45)", margin: 0 }}>{item.d}</p>
            </div>
          </div>
        ))}
      </div>

      {/* ESTRATÉGIA DE PREÇO */}
      <div style={s.section}>
        <div style={{ ...s.card, border: "1px solid rgba(249,115,22,0.2)" }}>
          <span style={s.label}>Quanto vale parar de perder?</span>
          <h2 style={{ ...s.h2, fontSize: 20 }}>Quanto você gastaria<br />para parar de apostar?</h2>
          <div style={s.compare}>
            <span style={{ fontSize: 13, color: "rgba(255,255,255,0.5)" }}>Perdas mensais médias</span>
            <span style={{ fontSize: 14, fontWeight: 700, color: "#f87171" }}>R$800/mês</span>
          </div>
          <div style={s.compare}>
            <span style={{ fontSize: 13, color: "rgba(255,255,255,0.5)" }}>Psicólogo especializado</span>
            <span style={{ fontSize: 14, fontWeight: 700, color: "#fbbf24" }}>R$200/sessão</span>
          </div>
          <div style={{ ...s.compare, borderBottom: "none" }}>
            <span style={{ fontSize: 13, color: "#fff", fontWeight: 600 }}>Anjora — proteção completa</span>
            <span style={{ fontSize: 15, fontWeight: 800, color: "#4ade80" }}>R$14,90/mês</span>
          </div>
          <p style={{ fontSize: 12, color: "rgba(255,255,255,0.35)", marginTop: 12, marginBottom: 0 }}>Menos que um lanche. Começa a funcionar no mesmo dia.</p>
        </div>
      </div>

      {/* CONTADOR */}
      <div style={s.section}>
        <div style={s.card}>
          <span style={s.label}>⚡ Oferta de acesso grátis acaba em</span>
          <div style={{ display: "flex", gap: 10 }}>
            {[{ v: hh, l: "HORAS" }, { v: mm, l: "MIN" }, { v: ss, l: "SEG" }].map((t) => (
              <div key={t.l} style={s.timerBox}>
                <p style={{ fontSize: 32, fontWeight: 800, margin: 0 }}>{t.v}</p>
                <p style={{ fontSize: 10, color: "rgba(255,255,255,0.4)", margin: 0 }}>{t.l}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* DEPOIMENTOS */}
      <div style={s.section}>
        <span style={s.label}>Quem já usou</span>
        <h2 style={s.h2}>O que estão <span style={s.orange}>falando</span></h2>
        {[
          { t: "Finalmente consigo abrir o Instagram sem ver propaganda de bet. Mudou minha vida.", n: "Carlos M.", c: "São Paulo" },
          { t: "Já tinha tentado parar antes. O Anjora foi o que faltava pra eu conseguir de verdade.", n: "Pedro R.", c: "Belo Horizonte" },
          { t: "Em 2 dias o app já bloqueou mais de 50 tentativas. Não acreditei que funcionava tão bem.", n: "Rafael S.", c: "Rio de Janeiro" },
        ].map((d, i) => (
          <div key={i} style={s.card}>
            <p style={{ color: "#f59e0b", fontSize: 16, margin: "0 0 8px" }}>★★★★★</p>
            <p style={{ fontSize: 14, lineHeight: 1.6, margin: "0 0 12px" }}>"{d.t}"</p>
            <p style={{ fontSize: 13, fontWeight: 700, margin: 0 }}>{d.n}</p>
            <p style={{ fontSize: 12, color: "rgba(255,255,255,0.4)", margin: 0 }}>{d.c}</p>
          </div>
        ))}
      </div>

      {/* FORMULÁRIO */}
      <div style={s.section} id="form">
        <div style={{ ...s.card, border: "1px solid rgba(249,115,22,0.2)", padding: "24px 20px" }}>
          <p style={{ fontSize: 18, fontWeight: 700, margin: "0 0 4px" }}>👋 Quer participar?</p>
          <p style={{ fontSize: 13, color: "rgba(255,255,255,0.45)", margin: "0 0 20px" }}>Preencha seus dados para receber as instruções de participação.</p>
          <input style={s.input} placeholder="Seu nome" value={form.nome} onChange={e => setForm({ ...form, nome: e.target.value })} />
          <input style={s.input} placeholder="WhatsApp com DDD (ex: 11999999999)" value={form.whatsapp} onChange={e => setForm({ ...form, whatsapp: e.target.value })} />
          <input style={s.input} placeholder="E-mail da conta Google do celular" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
          <p style={{ fontSize: 12, color: "rgba(255,255,255,0.3)", margin: "-4px 0 16px" }}>⚠️ Use o e-mail Google cadastrado no seu Android.</p>
          {erro && <p style={{ color: "#f87171", fontSize: 13, marginBottom: 10 }}>{erro}</p>}
          <button style={{ ...s.btn, opacity: loading ? 0.7 : 1 }} onClick={handleSubmit} disabled={loading}>
            {loading ? "ENVIANDO..." : "QUERO PARTICIPAR"}
          </button>
          <p style={{ fontSize: 11, color: "rgba(255,255,255,0.2)", textAlign: "center", marginTop: 12, marginBottom: 0 }}>Seus dados estão protegidos. Não compartilhamos com ninguém.</p>
        </div>
      </div>

      {/* FAQ */}
      <div style={s.section}>
        <span style={s.label}>Ainda na dúvida?</span>
        <h2 style={s.h2}>Perguntas frequentes</h2>
        {faqs.map((f, i) => (
          <div key={i} style={s.faqItem} onClick={() => setOpenFaq(openFaq === i ? null : i)}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ fontSize: 14, fontWeight: 600 }}>• {f.q}</span>
              <span style={{ ...s.orange, fontSize: 20, fontWeight: 300 }}>{openFaq === i ? "−" : "+"}</span>
            </div>
            {openFaq === i && <p style={{ fontSize: 13, color: "rgba(255,255,255,0.55)", margin: "10px 0 0", lineHeight: 1.6 }}>{f.a}</p>}
          </div>
        ))}
      </div>

      {/* CTA FINAL */}
      <div style={{ ...s.section, textAlign: "center" }}>
        <h2 style={s.h2}>Sua vida pode ser diferente<br /><span style={s.orange}>a partir de hoje.</span></h2>
        <p style={s.sub}>Participe do teste e seja um dos primeiros a usar o Anjora.</p>
        <button style={s.btn} onClick={() => document.getElementById("form").scrollIntoView({ behavior: "smooth" })}>
          QUERO PARTICIPAR DO TESTE
        </button>
        <p style={{ fontSize: 12, color: "rgba(255,255,255,0.3)", marginTop: 10 }}>Acesso em 24h · privado · sem cartão</p>
      </div>

      {/* RODAPÉ */}
      <div style={{ textAlign: "center", padding: "40px 20px 0", borderTop: "0.5px solid rgba(255,255,255,0.06)", marginTop: 48 }}>
        <img src="/logo512.png" alt="Anjora" style={{ width: 32, height: 32, borderRadius: 8, marginBottom: 8 }} />
        <p style={{ fontSize: 12, color: "rgba(255,255,255,0.2)", margin: 0 }}>© 2026 Anjora · suporte@anjora.com.br · anjora.com.br</p>
      </div>

    </div>
  );
};

export default Trial;
